import "./MoenFaucetSinkRepair.module.css";
import Header from "@/reusable_sections/Header";
import MoenHero from "./sections/MoenHero";
import MoenGuide from "./sections/MoenGuide";
import MoenTrust from "./sections/MoenTrust";
import Footer from "@/reusable_sections/Footer";
export default function MoenFaucetSinkRepairPage() {
  return <div>
      <Header />
      <MoenHero />
      <MoenGuide />
      <MoenTrust />
      <Footer />
    </div>;
}